import React, { Component } from "react";
import { connect } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form'
import { loadInitialCounterpartyMasterData } from './action';
import { Form, FormGroup, ModalHeader, ModalBody, ModalFooter, Row, Col, Button, Label } from 'reactstrap';
import { DOMESTIC, INTERNATIONAL } from '../../../../Analyst/Cases/constants';
import { toast } from 'react-toastify';

const required = value => value ? null : 'Required';
const renderField = ({ input, label, type, isRequired, disabled, meta: { touched, error, warning } }) => (
    <Row className="mb-3 align-items-center">
        <Col sm="9">
            <label className="mb-0">{label}</label>
            {(isRequired && <span className="text-danger">*</span>)}
        </Col>
        <Col sm="15">
            <input {...input} placeholder={label} disabled={disabled} type={type} className="form-control" />
            {touched &&
                ((error && <span className="text-danger">{error}</span>) ||
                    (warning && <span className="text-warning">{warning}</span>))}
        </Col>
    </Row>
)
class EditCounterpartyMasterDataForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialData: [],
            selectedCountry: '',
            selectedState: '',
            geographicType: ''
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.initialValues !== prevProps.initialValues) {
            this.setState({
                initialData: this.props.initialValues
            })
        }
    }

    searchCallback = (selected, type) => {
        if (type === 'countrySearch') {
            this.setState({
                selectedCountry: selected,
                selectedState: ''
            })
            this.props.change('country', selected)
            this.props.change('state', '')
        } else {
            this.setState({
                selectedState: selected.value
            })
            this.props.change('state', selected)
        }
    }

    handleCounterpartyGeographicChange = (event) => {
        this.setState({ geographicType: event.target.value })
        this.props.change('geographicType', event.target.value)
    }

    submitCounterpartyMasterData = (val) => {
        this.props.submitCounterpartyMasterData(val)
    }

    render() {
        const { value } = this.state;
        let field = []
        let inputPropsState = {
            placeholder: "Search State",
            value,
            onChange: this.onChange,
            disabled: false,
            className: "form-control"
        }
        let inputProps = {
            placeholder: "Search Country",
            value,
            onChange: this.onChange,
            disabled: false,
            className: "form-control"
        };
        if (this.state.initialData) {
            field = Object.keys(this.state.initialData).map((key, index) => {
                return (
                    <Field
                        key={key}
                        name={key}
                        type="text"
                        component={renderField}
                        label={key}
                    />
                )
            });

        }
        const { handleSubmit, pristine, submitting, reset } = this.props
        return (
            <Row>
                <form className="modal-content shadow-none border-0" onSubmit={handleSubmit((val) => this.submitCounterpartyMasterData(val))}>
                    <ModalHeader>
                        Counterparty Master Data
                    </ModalHeader>
                    <ModalBody>
                        {field}
                    </ModalBody>
                    <ModalFooter>
                        <Row>
                            <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.props.handleCounterpartMasterDataEditModelClosed()} > Cancel </Button></Col>
                            <Col ><Button type="submit" color="info" size="lg" className="justify-content-center" disabled={submitting}>Submit</Button></Col>
                        </Row>
                    </ModalFooter>
                </form>
            </Row>
        )
    }
}

EditCounterpartyMasterDataForm = reduxForm({
    form: 'editCounterpartyMasterDataForm', // a unique identifier for this form
    enableReinitialize: true
})(EditCounterpartyMasterDataForm);

EditCounterpartyMasterDataForm = connect(
    state => ({
        initialValues: state.counterpartyMasterDataInitialValuesReducer.intialCounterpartyMasterData // pull initial values from reducer
    }),
    { load: loadInitialCounterpartyMasterData }, // bind addition fields loading action creator
)(EditCounterpartyMasterDataForm);

export default EditCounterpartyMasterDataForm;
